import { type ApiService } from '../types/ApiService';
import { type DailyConcernsGet } from '@reliance/types/responses/AI';

export const ai = (centralApi: ApiService) => ({
  dailyConcerns: (
    facilityId: number,
    date?: string,
  ): Promise<DailyConcernsGet> => {
    const url = `/ai/facility/${facilityId}/daily-concerns`;
    const params = date ? { date } : undefined;
    return centralApi.get(url, params ? { params } : undefined);
  },
});
